module.exports = __webpack_public_path__ + "img/58-d93039.png";